import { observer } from 'mobx-react'
import { useState } from 'react'
import { LoadingSpinner } from '@/components/Generic'
import { axiosInstance } from '@/methods/axiosConfig'
import { API_URL, EASYSIGN_SERVICE_PATH } from '@/constants/apiUrl'
import { devLog } from '@/methods/devLog'
import { forceRedirect } from '@/methods/forceRedirect'
import { useInterval } from 'usehooks-ts'

interface PollingResponse {
  redirectUrl?: string
}

export const EasySignWaitCompletePage = observer(() => {
  const [shouldPoll, setShouldPoll] = useState(true)

  const checkStatus = async (): Promise<PollingResponse | undefined> => {
    try {
      const res = await axiosInstance.get<PollingResponse>(
        `${API_URL}/${EASYSIGN_SERVICE_PATH}/are-all-documents-signed`,
        {
          withCredentials: true,
        }
      )

      if (res?.data?.redirectUrl) {
        setShouldPoll(false)

        forceRedirect(res.data.redirectUrl)
      }

      return res.data
    } catch (e) {
      devLog(e)
    }
  }

  useInterval(checkStatus, shouldPoll ? 3000 : null)

  return (
    <div className="page-container mobile-m-10">
      <LoadingSpinner />
    </div>
  )
})
